import boletaApi from "./boletaApi";

export const getEmployees = async (idCompany) => {
  const params = idCompany ? { idCompany } : {};
  try {
    return await boletaApi.get("/getEmployees", { params });
  } catch (error) {
    const { response } = error;
    return response;
  }
};
